<template>
  <div class="login">

    <Title v-if="con.offer_id&&con.offer_status==0" titleName='修改报价' iconLeft="back"/>
    <Title v-if="!con.offer_id" titleName='我的报价' iconLeft="back"/>
    <Title v-if="con.offer_status==1" titleName='出票中' iconLeft="back"/>
    <!--    <img style="position: absolute;z-index: 0;width: 100%;height: 5.2rem" src="https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/6c557c89-a107-489e-a719-2fb92b0fd379.png" alt="" srcset="">-->
    <div class="box1">
      <div class="mem-con">
        <div class="tag" style="background: cornflowerblue" v-if="con.offer_status==1"
             v-clipboard:copy="con.movie_name+con.show_date+con.show_time+con.close_time+con.cinemas+con.halls+con.seat_names+con.order_no"
             v-clipboard:success="onCopy">

          出票中
        </div>
        <div class="tag" style="background: green" v-else-if="con.offer_status==0"
             v-clipboard:copy="con.movie_name+con.show_date+con.show_time+con.close_time+con.cinemas+con.halls+con.seat_names+con.order_no"
             v-clipboard:success="onCopy">

          竞价中
        </div>
        <div class="tag" style="background: red;color: white" v-else-if="con.offer_status==2"
             v-clipboard:copy="con.movie_name+con.show_date+con.show_time+con.close_time+con.cinemas+con.halls+con.seat_names+con.order_no"
             v-clipboard:success="onCopy">

          竞价成功
        </div>
        <div class="tag" style="background: #6DAD19" v-else-if="con.offer_status==3"
             v-clipboard:copy="con.movie_name+con.show_date+con.show_time+con.close_time+con.cinemas+con.halls+con.seat_names+con.order_no"
             v-clipboard:success="onCopy">

          已关闭
        </div>
        <div class="tag" style="background: #6DAD19" v-else-if="con.offer_status==4"
             v-clipboard:copy="con.movie_name+con.show_date+con.show_time+con.close_time+con.cinemas+con.halls+con.seat_names+con.order_no"
             v-clipboard:success="onCopy">

          已退回
        </div>
        <div class="heade">
          <!--      <img class="img1" :src="con.movie_image" alt="">-->
          <div class="mem-l1">

            <div class="tit">{{ con.movie_name }}</div>
            <p>{{ con.show_date }} {{ con.show_time }}~{{ con.close_time }}</p>
            <p>{{ con.halls }}</p>
            <div class="heade2" style="white-space:nowrap;overflow-x: auto;width: 80%">
              <p{{ con.seat_names }}
              <div style="margin-left: 10px;display: flex;align-items: center;color: #91d10b;" v-clipboard:copy="con.movie_name+';'+con.halls+';'+con.cinemas+';'+con.seat_names+';'+con.show_date +' '+ con.show_time +'~'+ con.close_time"
                   v-clipboard:success="onCopy">
                复制详情
              </div>
              </p>
            </div>

            <p>{{ con.cinemas }}</p>
            <p>地址:{{ con.address }}</p>
          </div>
        </div>
        <div class="heade2">
          <p>订单号：{{ con.order_no }}
          <div style="margin-left: 10px;color: red;" v-clipboard:copy="con.order_no"
               v-clipboard:success="onCopy">
            复制订单号
          </div>
          </p>
        </div>

      </div>
    </div>
    <div class="box1">
      <div class="h-act" v-if="con.offer_status==0">
        请在{{ con.offer_timeout }}分钟内进行报价，否则将失去竞价机会。
      </div>
    </div>
    <div class="box1">
      <div class="card-color">


        <div class="leaf">
          <div class="dont">
            座位
          </div>
          <div class="fit" style="white-space:nowrap;overflow-x: auto;width: 80%">
            {{ con.seat_names }}

          </div>
        </div>
        <div class="leaf">
          <div class="dont">
            类型
          </div>
          <div class="fit">
            <span class="font-col" v-if="con.seat_flag==0">普通座</span><span class="font-col" v-if="con.seat_flag==1">情侣左</span><span
              class="font-col" v-if="con.seat_flag==2">情侣右</span><span class="hand">|</span><span class="font-col"
                                                                                                     v-if="con.accept_seats==1">支持换座</span><span
              class="font-col" v-if="con.accept_seats==0">不支持换座</span>

          </div>
        </div>
        <div class="leaf">
          <div class="dont">
            市场价<span v-if="con.offer_id">/我的报价</span>
          </div>
          <div class="fit">
            <span class="font-col">{{ con.market_price }}元</span>

            <span class="hand">|</span><span class="font-col">{{ con.offer_amount }}元</span>
          </div>

        </div>

        <div class="bao" v-if="con.offer_status==0">
          <div class="dont">
            建议报价区间
            <p>{{ con.min_price }}-{{ con.max_price }}元</p>
          </div>


          <div class="fit">
            <input type="text" v-model="ruleForm.price" placeholder="请输入单价"/>
            <span>x{{ con.ticket_count }}</span>
          </div>

        </div>
        <div class="leaf" v-if="!con.offer_id">
          <div class="dont">
            报价倒计时 <img src="../../assets/tis.png"><span class="font-col h-ice">{{ m }}分{{ s }}秒</span>
          </div>

        </div>
        <div class="leaf" v-if="con.offer_status==1">
          <div class="dont">

            出票倒计时 <img src="../../assets/tis.png"><span class="font-col h-ice">{{ m }}分{{ s }}秒</span>
          </div>


        </div>
        <div class="leaf" v-if="con.offer_status==1">
          <div class="dont">
            请尽快出票

          </div>


        </div>
      </div>
    </div>
    <div class="box1">
      <div class="li-give" v-if="con.offer_status==1">
        <!--  <div class="li-give">-->
        <div class="tit">取票信息<img src="../../assets/noodles.png" @click="runned"></div>

        <div class="give">

          <div class="user_input">

            <div class="lab">取票码</div>
            <input v-model="ticket_code" placeholder="输入取票码"/>
            <van-uploader accept="image/*" :after-read="withOut">
              <img src="../../assets/pp1.png">
            </van-uploader>

          </div>
          <div class="user_input">

            <div class="lab">验证码</div>
            <input v-model="valid_code" placeholder="无验证码(选填)"/>

          </div>
          <div class="h-car-ed" v-for="(item,index) in stone">
            <div class="rich">{{ index + 1 }}</div>
            <div class="h-bir">
              <div class="ending">

                <div class="lab">取票码</div>
                <input v-model="item.ticket_code" placeholder="输入取票码"/>

              </div>
              <div class="ending">

                <div class="lab">验证码</div>
                <input v-model="item.valid_code" placeholder="无验证码(选填)"/>

              </div>
            </div>
          </div>


          <div class="h-late-der">
            <ul>
              <li v-for="(item,index) in sleep" @click="habit(index)">{{ item }}
                <img src="../../assets/bg1.png"/>
              </li>
              <div class="clear"></div>
            </ul>
          </div>

        </div>
      </div>
      <div class="li-give" v-if="con.offer_status==1">

        <div class="tit">取票二维码</div>
        <div class="h-water">
          <p class="font-col h-date">请仔细核对券码是否正确，上传错误券码造成损失的将自己承担！</p>

          <van-uploader
              v-model="uploader_FY"
              :after-read="afterRead"
              :before-delete="delUploadImg_FY"
              accept="image/*"
              multiple
          />
          <p class="font-col h-date">上传凭证</p>
        </div>

      </div>
      <div class="li-give" v-if="con.offer_status==2&&setshow()">

        <div class="tit">取票信息
          <img src="../../assets/noodles.png" @click="runned">
        </div>
        <div class="give">

          <div class="user_input">

            <div class="lab">取票码</div>
            <input v-model="ticket_code" placeholder="输入取票码"/>
            <van-uploader accept="image/*" :after-read="withOut">
              <img src="../../assets/pp1.png">
            </van-uploader>
          </div>
          <div class="user_input">

            <div class="lab">验证码</div>
            <input v-model="valid_code" type="number" placeholder="无验证码(选填)"/>

          </div>
          <div class="h-car-ed" v-for="(item,index) in con.ticket_code">
            <div class="rich">{{ index + 1 }}</div>
            <div class="h-bir">
              <div class="ending">

                <div class="lab">取票码</div>
                <input v-model="item.ticket_code" placeholder="输入取票码"/>

              </div>
              <div class="ending">

                <div class="lab">验证码</div>
                <input v-model="item.valid_code" placeholder="无验证码(选填)"/>

              </div>
            </div>
          </div>
          <div class="li-give" v-if="con.offer_status==2&&setshow()">

            <div class="tit">取票二维码</div>
            <div class="h-water">
              <p class="font-col h-date">请仔细核对券码是否正确，上传错误券码造成损失的将自己承担！</p>

              <van-uploader
                  v-model="uploader_FY"
                  :after-read="afterRead"
                  :before-delete="delUploadImg_FY"
                  accept="image/*"
                  multiple
              />
              <p class="font-col h-date">上传凭证</p>


            </div>

          </div>

        </div>
      </div>
    </div>
    <div class="box1">
      <div v-if="con.offer_status==0" class="h-heal-th">


        <p class="h-vad-ball"><!-- 只有一次报价，请谨慎报价 --></p>
        <div class="hb-button" v-if="con.offer_id" @click="loginForm">确认修改</div>
        <div class="hb-button" v-else @click="loginForm">确认报价</div>

      </div>

      <div class="fast" v-if="con.offer_status==1">


        <div class="h-pap">
          <div class="h-button ad" v-if="con.seat_status==0" @click="honor">释放座位</div>
        </div>
        <div class="h-pap">
          <div class="h-button cloud" @click="ticket">出票</div>
          请认真核对确保无误
        </div>
        <div class="h-pap">
          <div class="h-button ad" style="background-color: #8684f3" @click="white">转单</div>
          请不要轻易转单影响奖励
        </div>
      </div>
      <div class="fast" v-if="con.offer_status==1">


      </div>
      <div class="fast" v-if="con.offer_status==2&&setshow()">

        <div class="h-button sound" @click="ticket">修改</div>


      </div>
      <div class="fast" v-if="con.offer_status>0">

      </div>
    </div>
    <div class="box1">
      <van-dialog v-model="del" @confirm='pick' show-cancel-button>
        <div class="link">
          <div class="want">
            <img v-if="but.images" :src="but.images"/>
            <van-uploader v-else :after-read="afterRead">
              <van-button round block native-type="submit">
                上传出票图
              </van-button>
            </van-uploader>
          </div>

          <div class="gand">
            <ul>
              <li>
                <input type="text" v-model="but.code" placeholder="取票码(必填)"/>
              </li>
              <li>
                <input type="text" v-model="but.valid_code" placeholder="验证码(非必填)"/>
              </li>
            </ul>
          </div>
        </div>
      </van-dialog>
      <van-dialog v-model="der" title="更换座位" @confirm='half'>
        <div class="h-plat">
          座位 <input type="text" v-model="c1"/>排 <input type="text" v-model="c2"/>号
        </div>
      </van-dialog>
      <van-dialog v-model="chai" title="选择拆分" @confirm='chaiok'>
        <div class="user_input">
          <input v-model="ticket_code" placeholder="输入取票码"/>
          <div class="button1" @click="getcode(chaidata)">以|拆分</div>
        </div>
        <div class="user_input">
          <input v-model="valid_code" placeholder="无验证码(选填)"/>
          <div class="button2" @click="getcode2(chaidata)">后6拆分</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import Title from "@/common/title";
import Bar from '@/components/bar/bar'
import {Toast, Dialog} from 'vant';
import QrCode from 'qrcode-decoder/dist/index'

export default {
  components: {
    Title,
    Bar

  },
  data() {
    return {
      imgurl: '',
      checked: false,
      user: '',
      active: 1,
      id: '',
      chai: false,
      chaidata: {},
      m: 0,
      s: 0,
      file: '',
      pink: '',
      der: false,
      uploader_FY: [],
      stone: [],
      con: '',
      c1: '',
      c2: '',
      del: false,
      ticket_code: '',
      valid_code: '',
      sleep: [],
      but: {
        order_no: '',
        images: [],
        new_seat_names: '',
        code: []
      },
      ruleForm: {
        price: '',
        order_no: ''
      }

    };
  }, mounted() {

    this.id = this.$route.query.id
    this.ruleForm.order_no = this.id
    this.funder()
    this.sandMate();
  }, methods: {
    setshow() {
      //电影如果开演时间小于当前时间则不显示修改按钮,this.con.show_date+this.con.show_time
      var year = new Date().getFullYear();

      var show_time = year + '-' + this.con.show_date + ' ' + this.con.show_time + ':00';
      console.log(show_time);
      var show_time = new Date(show_time.replace(/-/g, "/")).getTime();
      var now_time = new Date().getTime();
      console.log(show_time, now_time);
      if (show_time < now_time) {
        return false;
      } else {
        return true;
      }
    },
    runned() {
      if (!this.ticket_code) {
        Toast("请填写取票码")
        return
      } else {
        let lar = {ticket_code: this.ticket_code, valid_code: this.valid_code}
        this.stone.push(lar)
        this.ticket_code = ''
        this.valid_code = ''
      }

    }, onCopy() {
      Toast("复制成功")
    }, ctime() {


      var now = Math.round(new Date().getTime() / 1000)


      var endDate = new Date(this.con.expire_time);
      var end = endDate.getTime();


      var leftTime = end - now;


      if (leftTime >= 0) {


        this.m = Math.floor(leftTime / 60 % 60);
        this.s = Math.floor(leftTime % 60);

      }


      setTimeout(this.ctime, 1000);
    }, afterRead(file) {

      this.$axios({
        method: "post",
        url: "stores/upload",
        data: {file: file.content}
      }).then((res) => {

        let data = res.data;
        if (data.code == 200) {

          this.but.images.push(data.data.img)
        }

      });


    },
    chaiok() {
      this.chai = false
    },
    withOut(file) {
      let url = window.webkitURL.createObjectURL(file.file)
       console.log(url)
      console.log(file)
      let qrr = new QrCode()
      qrr.decodeFromImage(url).then(val => {
        console.log('二维码解析成功')
        console.log(val)
        this.chaidata = val.data
       let fond=val.data.split("|")
        if (fond.length == 2) {
          this.ticket_code = fond[0]
          this.valid_code = fond[1]
        } else {
          this.ticket_code = fond[0]
        }

       });
       this.chai = true
    },
    decode(img) {
      this.$axios({
        method: "get",
        url: "https://www.devtool.top/api/qrcode/decode/remote?url=" + img,
      }).then((res1) => {

        this.chaidata = res1
        this.getcode(res1)
        console.log(this.chaidata)
        this.chai = true
      });
    },
    getcode(res) {
      let data = res;
      console.log(data)
      let fond = data.split("|")
      console.log(fond)
      this.ticket_code=''
      this.valid_code=''
      if (fond.length == 2) {
        this.ticket_code = fond[0]
        this.valid_code = fond[1]
      } else {
        this.ticket_code = fond[0]
      }
    },
    getcode2(res) {
      let data = res;
      let data1 = data.substring(data.length - 6, data.length)
      this.valid_code = data1
      this.ticket_code = data.substring(0, data.length - 6)
    },
    habit(fell) {
      this.der = true
      this.pink = fell
    },
    ticket() {
      let but = this.but

      but.order_no = this.id

      but.images = but.images.join(',')

      but.new_seat_names = this.sleep.join(',')

      if (this.ticket_code) {
        let lar = {ticket_code: this.ticket_code, valid_code: this.valid_code}
        this.stone.push(lar)
      }

      if (this.con.ticket_code.length > 0) {
        but.code = JSON.stringify(this.con.ticket_code)

      } else {
        but.code = JSON.stringify(this.stone)

      }


      this.$axios({
        method: "post",
        url: "stores/out_ticket_one",
        data: but
      }).then((res) => {
        let data = res.data;

        if (data.code == 200) {

          this.$router.push({path: "/user/orders"});
          Toast(data.message);


        } else {
          Toast(data.message);
          this.but.images = []
        }

      });


    },
    half() {
      this.der = false
      this.sleep[this.pink] = this.c1 + '排' + this.c2 + '座'
    },
    pick() {

      this.but.order_no = this.id

      this.$axios({
        method: "post",
        url: "stores/create_ticket",
        data: this.but
      }).then((res) => {
        let data = res.data;

        if (data.code == 200) {

          this.funder()
          Toast(data.message);


        } else {
          Toast(data.message);

        }

      });


    }, loginForm() {

      if (this.ruleForm.price == '') {

        Toast('请输入单价');
        return
      }


      this.$axios({
        method: "post",
        url: "stores/create_offer",
        data: this.ruleForm,
      }).then((res) => {
        let data = res.data;

        if (data.code == 200) {

          this.$router.back()
          Toast(data.message);


        } else {
          Toast(data.message);

        }

      });


    }, white() {

      Dialog.confirm({
        message:
            '是否转单',
      })
          .then(() => {
            this.$axios({
              method: "post",
              url: "stores/backout",
              data: {order_no: this.id}
            }).then((res) => {
              let data = res.data;

              if (data.code == 200) {

                this.$router.back()
                Toast(data.message);


              } else {
                Toast(data.message);

              }

            });

          })


    }, fight() {


      this.$axios({
        method: "post",
        url: "stores/cancel_offer",
        data: {offer_id: this.con.offer_id}
      }).then((res) => {
        let data = res.data;

        if (data.code == 200) {

          this.$router.back()
          Toast(data.message);


        } else {
          Toast(data.message);

        }

      });


    }, honor() {


      this.$axios({
        method: "post",
        url: "stores/release-seat",
        data: {order_no: this.id}
      }).then((res) => {
        let data = res.data;

        if (data.code == 200) {

          this.funder()
          Toast(data.message);


        } else {
          Toast(data.message);

        }

      });


    }, funder() {

      this.$axios.get('stores/order_info', {
        params: {
          order_no: this.id
        }
      }).then((res) => {
        // res={}
        //  res.data = {"code":200,"message":"","data":{"order_no":"CK20221126135741531005","ticket_count":1,"movie_name":"\u6cbc\u6cfd\u6df1\u5904\u7684\u5973\u5b69","show_time":"17:29","close_time":"19:29","cinema_id":3173024,"cinemas":"\u4e0a\u6d77\u5e02 \u00b7 \u5510\u5fb7\u56fd\u9645\u5f71\u57ce\u2014\u4e0a\u6d77\u7f57\u6cfe\u5e97","amount":45,"buyer_phone":"","accept_seats":1,"seat_flag":"0","market_price":45,"halls":"\u4e94\u53f7\u5385\uff08\u7981\u6b62\u996e\u98df\uff09","seat_names":"而微软特为热个我热我热吧而我更认为热热服务费","expire_time":1669444248,"offer_status":2,"show_version":"\u56fd\u8bed 2D","store_id":121,"movie_image":"https:\/\/gw.alicdn.com\/tfscom\/i4\/O1CN016sRRcY1KNf44THzzC_!!6000000001152-0-alipicbeacon.jpg_320x320.jpg","address":"\u5b9d\u5c71\u533a\u7f57\u6cfe\u9547\u8427\u6708\u8def7-11\uff08\u5355\uff093\u5c42\u533a\u5510\u5fb7\u56fd\u9645\u5f71\u57ce\u7f57\u6cfe\u5e97","offer_amount":0.1,"offer_id":2378,"show_date":"11-30","min_price":"1","max_price":40.5,"seat_status":0,"ticket_timeout":30,"offer_timeout":3}}
        let data = res.data;
        if (data.code === 200) {

          this.con = data.data
          this.ctime()
          this.but.new_seat_names = this.con.seat_names
          this.sleep = this.but.new_seat_names.split(',')
          this.stone = this.con.ticket_code
          this.con.images = this.con.images
          if (this.con.images) {
            this.but.images = this.con.images
          }

          if (this.con.offer_status == 2) {
            this.con.images.forEach(item => {
              this.uploader_FY.push({url: item})
            })
          }

          this.ruleForm.order_no = this.id

        }
      })


    }
  }
};
</script>
<style lang="scss" scoped>
.button1 {
  padding: 0.08rem 0.2rem;
  background: blue;
  border-radius: 0.4rem;
  color: white;
  width: 1.4rem;
  text-align: center;
}

.button2 {
  padding: 0.08rem 0.2rem;
  background: red;
  border-radius: 0.4rem;
  color: white;
  width: 1.4rem;
  text-align: center;
}

.heade {
  display: flex;
  // align-items: center;
  width: 100%;
}

.heade2 {
  display: flex;
  color: #ffffff;
  width: 100%;

}

//.box1{
//  padding: 10px 20px 0px 20px;
//  position: relative;
//}
.login {

  h1 {

    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 20px;

  }

  background: #F4F4F4;
  overflow: hidden;
  position: relative;
  //height: 100vh;
}

.pro-tit {
  text-align: center;
  line-height: 40px;
  padding: 20px 0;

  h3 {
    font-size: 36px;
  }

  p {
    font-size: 24px;
  }
}

.h-vad-ball {
  text-align: center;
  margin-top: 20px;
}

.h-date {
  margin-bottom: 20px;
}

.h-car-ed {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;

  .rich {
    width: 55px;
    height: 55px;
    margin-left: 30px;
    margin-top: 20px;
    background: #F3F2F6;
    border-radius: 50%;
    font-size: 30px;
    text-align: center;
    line-height: 55px;
  }

  .h-bir {
    width: 630px;

    .ending {
      color: #000000;
      font-size: 28px;
      height: 100px;
      display: flex;
      margin-left: 30px;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding-right: 20px;

      .lab {
        width: 110px;
        display: flex;
        align-items: center;

        img {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }

      span {
        color: #E72E34;
        margin-left: 10px;

      }

      input {
        text-align: left;
        padding-left: 20px;
      }

      .ip {
        width: 30px;

        img {
          width: 100%;
        }
      }

    }

    .ending input {
      flex: 1;
      height: 66px;
      font-size: 22px;
      color: #6d6d6d;
      background: none;
      outline: none;
      border: 1px solid #eee;
    }
  }
}

.h-fad {
  text-align: center;
  font-size: 30px;
  display: flex;
  justify-content: center;
  margin-top: 20px;

  img {
    width: 40px;
    margin-right: 10px;
  }
}

.mem-con {
  flex-direction: column;
  background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/6c557c89-a107-489e-a719-2fb92b0fd379.png) no-repeat;
  //background: url(https://vkceyugu.cdn.bspapp.com/VKCEYUGU-dba7ffc8-6102-457c-8941-6212ed989b04/f108cb3f-467d-4b20-9316-330b014b421d.png) no-repeat;
  font-size: 24px;
  color: black;
  padding: 30px;
  position: relative;
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  background-size: 100% 100%;

}

.img1 {
  width: 2rem;
  margin-right: 20px;
  flex: 2;
  height: 3rem;
}

.tag {
  width: 160px;
  height: 48px;
  right: 0;
  background: #FFFFFF;
  position: absolute;
  color: #222222;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 24px 0px 0px 24px;

  img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

}

.mem-l1 {
  flex: 8;
  color: #ffffff;

  .tit {
    font-size: 0.6rem;
    margin: 20px 0;
    font-weight: bold;
    color: white;
  }

  p {
    //font-size: 20px;
    line-height: 40px;
  }


}


.mem-l2 {
  background: #FFFFFF;
  padding: 30px;
  margin-bottom: 20px;

  .tit {
    display: flex;
    justify-content: space-between;

    h3 {
      font-size: 30px;
      color: #000000;
    }

    p {
      display: flex;

      img {
        width: 30px;
        height: 30px;
      }
    }
  }

  ul {
    display: flex;

    li {
      width: 20%;
      text-align: center;
      padding: 30px 0;

      img {
        width: 56px;
      }
    }

  }

  .min {
    li {
      width: 25%;
    }

  }
}

.card-color {
  border-radius: 10px;
  background: #fff;

  .leaf {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    padding: 30px 0;
    padding-right: 30px;
    margin-left: 30px;
    height: 40px;
    font-size: 28px;
    color: #000000;

    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      color: #000000;
    }

    .dont {
      display: flex;
      align-items: center;
      color: red;

      img {
        width: 32px;
        height: 32px;
        margin-right: 15px;
      }
    }

    .fit {
      color: #999999;

      img {
        width: 30px;
        height: 30px;
      }

      span {
        margin-left: 10px;
      }
    }

    .font-col {
      color: #FF5E00;
    }

    .hand {
      margin: 0 10px;
    }
  }

  .bao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
    padding: 50px 0;
    padding-right: 30px;
    margin-left: 30px;
    height: 40px;
    font-size: 28px;
    color: #000000;

    a {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      color: #000000;
    }

    .dont {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 32px;
        height: 32px;
        margin-right: 15px;
      }

      p {
        color: #FF5E00;
      }
    }

    .fit {


      input {
        width: 140px;
        border: none;
        height: 60px;
        border-bottom: 1px solid #EAEAEA;
      }

      span {
        color: #FF5E00;
        margin-left: 20px;
      }
    }

    .hand {
      margin: 0 10px;
    }
  }
}

.font-col {
  color: #FF5E00;
}

.hb-button {
  margin: 30px;
  height: 100px;
  background: #FF5E00;
  border-radius: 50px;
  color: #FFFFFF;
  font-size: 28px;
  text-align: center;
  line-height: 100px;

}

.h-heal-th {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;

  .hb-button {
    width: 200px;
  }
}

.fight {
  color: #FF5E00;
  font-size: 28px;
  text-align: center;
}

.h-act {
  padding: 20px;
}

.user_input {

  color: #000000;
  font-size: 28px;
  height: 100px;
  border-bottom: 1px solid #eee;
  display: flex;
  margin: 0 30px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  .lab {
    width: 110px;
    display: flex;
    align-items: center;

    img {
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
  }

  span {
    color: #E72E34;
    margin-left: 10px;

  }

  input {
    text-align: left;
    flex: 1;

  }

  .ip {
    width: 30px;

    img {
      width: 100%;
    }
  }

}

.user_input input {
  height: 46px;
  font-size: 22px;
  color: #6d6d6d;
  background: none;
  outline: none;
  border: none;
}

.user_input img {

  width: 40px;
  height: 40px;

}

.h-ice {
  margin-left: 20px;
}

.li-give {
  background: #FFFFFF;
  margin-top: 30px;
  margin-bottom: 30px;

  .tit {
    height: 90px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    margin-left: 30px;
    align-items: center;
    padding-right: 30px;
    font-size: 28px;

    img {
      width: 40px;
      height: 40px;
    }
  }

  .h-water {
    padding: 30px;
    font-size: 25px;

    .h-season {
      img {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }

  .give {

    .bear {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #999999;
      font-size: 28px;
      padding-top: 40px;

      img {
        width: 200px;
        height: 200px;
      }

      p {
        font-size: 60px;
        margin-bottom: 30px;
      }

      .stone {
        width: 100%;
        height: auto;
      }
    }
  }
}

.fast {
  height: 110px;
  background: #FFFFFF;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;

  .h-button {
    width: 200px;
    height: 80px;
    background: #F10018;
    border-radius: 40px;
    color: #FFFFFF;
    font-size: 28px;
    text-align: center;
    line-height: 80px;
  }

  .h-pap {
    width: 200px;
    height: 120px;

    .h-button {
      margin-bottom: 10px;
    }
  }

  .ad {
    background: #FFBB1D;
  }

  .cloud {
    background: #FF5E00;
  }

  .sound {
    width: 100%;
  }
}

.h-late-der {
  padding: 30px;

  li {
    width: 165px;
    float: left;
    height: 60px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;

    img {
      width: 19px;
      height: 19px;
      margin-left: 10px;
    }
  }
}

.link {
  text-align: center;

  .want {
    margin: 30px 0;

    img {
      height: 300px;
    }
  }

  .gand {
    ul {
      margin: 0 30px;

      li {
        border-bottom: 1px solid #eeeeee;

        input {
          border: none;
          width: 100%;
          height: 100px;
          text-align: left;
        }
      }
    }
  }
}

.h-plat {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px;

  input {
    width: 160px;
    height: 60px;
    background: #FFFFFF;
    border: 1px solid #ECECEC;
    border-radius: 8px;
    margin: 0 20px;
  }
}
</style>
